import ConsoleApi from "apps/console/enums/consoleApi";
import { useGetApiData, usePostApiData } from "shared/datalayer";
import {
  ApiParticipantListRequestBySearchCriteria,
  ApiProgramWorkFlowParticipantListingConfig,
  ApiProgramWorkFlowParticipantListingPage
} from "./types";

export function useGetParticipantsForProgram(
  successHandler: (data?: ApiProgramWorkFlowParticipantListingPage) => void
) {
  return usePostApiData<ApiProgramWorkFlowParticipantListingPage, ApiParticipantListRequestBySearchCriteria>(
    ConsoleApi.GET_PARTICIPANTS_FOR_PROGRAM,
    { onSuccess: data => successHandler(data) }
  );
}

export function useGetApplicableTagsForProgram(programId?: string) {
  return useGetApiData<ApiProgramWorkFlowParticipantListingConfig>(
    ConsoleApi.GET_APPLICABLE_TAGS_FOR_PROGRAM,
    { params: { programId } },
    { enabled: Boolean(programId) }
  );
}
